import React, { createContext, useMemo, useState } from 'react';

type KnowledgeProductsYearFilterContextType = {
  selectedYear: number;
  setSelectedYear: (year: number) => void;
  availableYears: number[];
  setAvailableYears: (years: number[]) => void;
  selectedProductTypeId: number;
  setSelectedProductTypeId: (productTypeId: number) => void;
  availableProductTypes: Array<{ id: number; label: string }>;
  setAvailableProductTypes: (types: Array<{ id: number; label: string }>) => void;
  selectedPreparationYear: number;
  setSelectedPreparationYear: (year: number) => void;
  availablePreparationYears: number[];
  setAvailablePreparationYears: (years: number[]) => void;
  selectedPipelineId: number;
  setSelectedPipelineId: (pipelineId: number) => void;
  availablePipelines: Array<{ id: number; label: string }>;
  setAvailablePipelines: (pipelines: Array<{ id: number; label: string }>) => void;
};

export const KnowledgeProductsYearFilterContext = createContext<KnowledgeProductsYearFilterContextType>({
  selectedYear: 0,
  setSelectedYear: () => {},
  availableYears: [],
  setAvailableYears: () => {},
  selectedProductTypeId: 0,
  setSelectedProductTypeId: () => {},
  availableProductTypes: [],
  setAvailableProductTypes: () => {},
  selectedPreparationYear: 0,
  setSelectedPreparationYear: () => {},
  availablePreparationYears: [],
  setAvailablePreparationYears: () => {},
  selectedPipelineId: 0,
  setSelectedPipelineId: () => {},
  availablePipelines: [],
  setAvailablePipelines: () => {},
});

export const KnowledgeProductsYearFilterProvider: React.FC = ({ children }) => {
  const [selectedYear, setSelectedYear] = useState<number>(0);
  const [availableYears, setAvailableYears] = useState<number[]>([]);
  const [selectedProductTypeId, setSelectedProductTypeId] = useState<number>(0);
  const [availableProductTypes, setAvailableProductTypes] = useState<Array<{ id: number; label: string }>>([]);
  const [selectedPreparationYear, setSelectedPreparationYear] = useState<number>(0);
  const [availablePreparationYears, setAvailablePreparationYears] = useState<number[]>([]);
  const [selectedPipelineId, setSelectedPipelineId] = useState<number>(0);
  const [availablePipelines, setAvailablePipelines] = useState<Array<{ id: number; label: string }>>([]);

  const value = useMemo(
    () => ({
      selectedYear,
      setSelectedYear,
      availableYears,
      setAvailableYears,
      selectedProductTypeId,
      setSelectedProductTypeId,
      availableProductTypes,
      setAvailableProductTypes,
      selectedPreparationYear,
      setSelectedPreparationYear,
      availablePreparationYears,
      setAvailablePreparationYears,
      selectedPipelineId,
      setSelectedPipelineId,
      availablePipelines,
      setAvailablePipelines,
    }),
    [
      selectedYear,
      availableYears,
      selectedProductTypeId,
      availableProductTypes,
      selectedPreparationYear,
      availablePreparationYears,
      selectedPipelineId,
      availablePipelines,
    ],
  );

  return (
    <KnowledgeProductsYearFilterContext.Provider value={value}>
      {children}
    </KnowledgeProductsYearFilterContext.Provider>
  );
};
